module.exports = __webpack_public_path__ + "static/media/switch.4f81ec43.png";